import { UserRoles } from '@/enums';
import { CompaniesUsers } from '@/modules/companies-users/types';

const access_roles = {
  [CompaniesUsers.Pages.COMPANIES_USERS_MANAGERS]: [UserRoles.External.ADMIN],
  [CompaniesUsers.Pages.COMPANY_USER_STAFF]: [UserRoles.External.ADMIN],
  [CompaniesUsers.Pages.COMPANY_USER_STAFF_DETAILS]: [UserRoles.External.ADMIN],
  [CompaniesUsers.Pages.COMPANY_USER_STAFF_EDIT]: [UserRoles.External.ADMIN],
};

export default access_roles;
